<style>
  .adminmfa-userid-cell,
  .adminmfa-userid-cell .adminmfa-userid-value {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    word-break: break-word;
    overflow-wrap: anywhere;
    line-height: 1.25;
  }
</style>

<div class="dtf-accountdetails">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>
  <br>
  <div class="container_dashboard" >
    <br><br><br>
    <div class="cardlike">
      <div style="display: flex; justify-content: center; flex-wrap: wrap; gap: 12px;">
        <button type="submit" (click)="unlock($event)" class="mbfs-button">{{ 'LoginModal.Unlock' | translate }}</button>
        <button type="submit" (click)="changeEmail($event)" class="mbfs-button">{{'LoginModal.ChangeEmail' | translate
          }}</button>
        <button type="submit" (click)="resetPassword($event)" class="mbfs-button">{{ 'LoginModal.ResetPassword' | translate
        }}</button>
        <button type="submit" (click)="inactivate($event)" class="mbfs-button">{{ 'LoginModal.Inactivate' | translate
        }}</button>
        <button type="submit" (click)="reactivate($event)" class="mbfs-button">{{ 'LoginModal.Reactivate' | translate
        }}</button>
        <button type="submit" (click)="raiseIncidentTicket($event)" class="mbfs-button">Raise Incident Ticket</button>
      </div>
      <br><br>
    </div>
    <br>
  <h6 class="mbfs-modal-header">Please select one account below to proceed with the above actions.</h6>
  <br>
  <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
    <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns; last as isLast; first as isFirst;">

      <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
        <div *ngIf="!isFrench"> {{column.display}}</div>
        <div *ngIf="isFrench"> {{column.displayFR}}</div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="{'adminmfa-userid-cell': column.name === 'userID'}">
        <div *ngIf="isFirst">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null"
            [checked]="selection.isSelected(element)">
          </mat-checkbox>
        </div>
        <span class="mobile-label">
          <div *ngIf="!isFrench"> {{column.display}} :</div>
          <div *ngIf="isFrench"> {{column.displayFR}} :</div>
        </span>
        <div *ngIf="column.dispFormat=='currency'">
          {{element[column.name] | currency:'USD':true:'1.2-2'}}
        </div>
        <div *ngIf="column.dispFormat=='contract'">
          {{element[column.name]}}
        </div>
        <div *ngIf="column.dispFormat==''" [ngClass]="{'adminmfa-userid-value': column.name === 'userID'}" [attr.title]="column.name === 'userID' ? element[column.name] : null">
          {{element[column.name]}}
        </div>
        <div *ngIf="column.dispFormat=='date'">
          {{element[column.name] | date:'MM/dd/yyyy'}}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="userList">
      <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
        [attr.colspan]="displayedColumns.length">
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
      [class.example-expanded-row]="userList === element" (click)="userList = userList === element ? null : element">
    </mat-row>
    <mat-row *matRowDef="let row; columns: ['userList']" class="example-detail-row"></mat-row>
    <!--No data message-->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        No records found.
      </td>
    </tr>

  </mat-table>
  <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
 
  </div>
</div>
<form [formGroup]="userForm" *ngIf="openModel">
  <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite" [attr.aria-hidden]="openModel"
    [class.open]="this.openModel === true">
    <div class="mbfs-modal-overlay"></div>
    <div class="mbfs-modal-content">
      <h3 class="mbfs-modal-header">Update Customer Email</h3>
      <div class="mbfs-bank-profile-create-inner">
        <div class="mbfs-text-input">
          <div class="form-group row m-2">
            <div class="input-group">
              <label class="col-md-3 col-form-label" for="userId">{{ 'LoginModal.UserLabel' | translate }}</label>
              <input type="text" id="userId" readonly [(ngModel)]="userId" name="userId" class="col-md-8 form-control"
                formControlName="userId" value="" autocomplete="off" />
            </div>
          </div>
        </div>
        <div class="mbfs-text-input">
          <div class="form-group row m-2">
            <div class="input-group">
              <label class="col-md-3 col-form-label" for="currentEmail">{{ 'LoginModal.CurrentEmail' | translate
                }}</label>
              <input type="text" id="currentEmail" readonly [(ngModel)]="currentEmail" name="currentEmail"
                class="col-md-8 form-control" formControlName="currentEmail" value="" autocomplete="off" />
            </div>
          </div>
        </div>
        <br>
        <div class="mbfs-text-input">
          <div class="form-group row m-2">
            <div class="input-group">
              <label class="col-md-3 col-form-label" for="newEmail">{{ 'LoginModal.NewEmail' | translate }}</label>
              <input type="text" formControlName="newEmail" class="col-md-8 form-control"
                [ngClass]="{ 'is-invalid': submitted && f.newEmail.errors }" />
            </div>
          </div>
        </div>
        <div class="mbfs-text-input">
          <div class="form-group row m-2">
            <div class="input-group">
              <label class="col-md-3 col-form-label" for="verifyEmail">{{ 'LoginModal.ReEnterEmail' | translate
                }}</label>
              <input type="text" formControlName="verifyEmail" class="col-md-8 form-control"
                [ngClass]="{ 'is-invalid': submitted && f.verifyEmail.errors }" />
            </div>
          </div>
        </div>


        <!--Error Msg Display-->
        <p style="color: red;" *ngIf="emailDontMatch">{{ 'LoginModal.ReEnterEmailCheck' | translate }}</p>
        <div *ngIf="submitted && f.newEmail.errors">
          <div style="color: red;" *ngIf="f.newEmail.errors?.required">Email is required</div>
          <div style="color: red;" *ngIf="f.newEmail.errors?.email">Email must be a valid email address</div>
        </div>
        <br>
        <button type="submit" class="mbfs-button" (click)="closeModal($event)">{{ 'LoginModal.Cancel' | translate
          }}</button>
        <button type="submit" class="mbfs-button" (click)="submitEmail($event)">{{ 'LoginModal.Submit' | translate
          }}</button>
        <button type="link" class="link mbfs-modal-close" (click)="closeModal($event)">X</button>
        <br>
      </div>
    </div>

  </div>
</form>

<!-- User unlocked success msg-->
<form *ngIf="openUnlockMsgModel">
  <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
    [attr.aria-hidden]="openUnlockMsgModel" [class.open]="this.openUnlockMsgModel === true">
    <div class="mbfs-modal-overlay"></div>
    <div class="mbfs-modal-content" style="max-height: 40% !important;max-width: 40.25rem !important">
      <br>
      <h5 style="color: black;">Selected user account has been unlocked!</h5>
      <br>
      <button type="submit" class="mbfs-button" (click)="closeMsgModel($event)">{{ 'LoginModal.Continue' |
        translate }}</button>
    </div>
  </div>
</form>

<!-- User Email Updated success msg-->
<form *ngIf="showEmailUpdateMsg">
  <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
    [attr.aria-hidden]="showEmailUpdateMsg" [class.open]="this.showEmailUpdateMsg === true">
    <div class="mbfs-modal-overlay"></div>
    <div class="mbfs-modal-content" style="max-height: 40% !important;max-width: 40.25rem !important">
      <br>
      <h5 style="color: black;">Selected user email has been updated!</h5>
      <br>
      <button type="submit" class="mbfs-button" (click)="closeMsgModel($event)">{{ 'LoginModal.Continue' |
        translate }}</button>
    </div>
  </div>
</form>

<!--Password reset success msg-->
<form *ngIf="showPwdResetMsg">
  <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
    [attr.aria-hidden]="showPwdResetMsg" [class.open]="this.showPwdResetMsg === true">
    <div class="mbfs-modal-overlay"></div>
    <div class="mbfs-modal-content" style="max-height: 45% !important;max-width: 45.25rem !important">
      <br>
      <h5 style="color: black;"> {{ 'LoginModal.PwdResetInstructions' |
        translate }} - {{ currentEmail }}</h5>
      <br>
      <button type="submit" class="mbfs-button" (click)="closeMsgModel($event)">{{ 'LoginModal.Continue' |
        translate }}</button>
    </div>
  </div>
</form>

<!-- User unlocked success msg-->
<form *ngIf="openInactiveMsgModel">
  <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
    [attr.aria-hidden]="openInactiveMsgModel" [class.open]="this.openInactiveMsgModel === true">
    <div class="mbfs-modal-overlay"></div>
    <div class="mbfs-modal-content" style="max-height: 40% !important;max-width: 40.25rem !important">
      <br>
      <h5 style="color: black;">Selected user account has been Inactivated!</h5>
      <br>
      <button type="submit" class="mbfs-button" (click)="closeMsgModel($event)">{{ 'LoginModal.Continue' |
        translate }}</button>
    </div>
  </div>
</form>

<form *ngIf="openReactiveMsgModel">
  <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
    [attr.aria-hidden]="openReactiveMsgModel" [class.open]="this.openReactiveMsgModel === true">
    <div class="mbfs-modal-overlay"></div>
    <div class="mbfs-modal-content" style="max-height: 40% !important;max-width: 40.25rem !important">
      <br>
      <h5 style="color: black;">Selected user account has been Reactivated!</h5>
      <br>
      <button type="submit" class="mbfs-button" (click)="closeMsgModel($event)">{{ 'LoginModal.Continue' |
        translate }}</button>
    </div>
  </div>
</form>
